import React from "react";
import ShareButton from "../ShareButton.jsx";

const TwitterButton = ({ mediaShareURL, shareText, mediaType, gameData, sectionName }) => {
  let utm = "";
  if (sectionName === "Action Replay") {
    utm = "utm_source=Stories&utm_medium=x_share&utm_campaign=action_replay";
  } else if (sectionName === "Group Photo") {
    utm = "utm_source=Stories&utm_medium=x_share&utm_campaign=group_photo";
  } else if (sectionName === "Games") {
    utm = "utm_source=Stories&utm_medium=x_share&utm_campaign=game_badge";
  } else if (sectionName === "Loop Cams") {
    utm = "utm_source=Stories&utm_medium=x_share&utm_campaign=loop_cam";
  }

  const separator = mediaShareURL.includes("?") ? "&" : "?";
  const fullUrl = mediaShareURL + separator + utm;
  const encodedUrl = encodeURIComponent(`${shareText} ${fullUrl}`);

  return (
    <ShareButton
      // onClick={() => window.open("http://x.com/intent/tweet?text=" + shareText + " " + encodeURI(mediaShareURL))}
      onClick={() => window.open(`https://x.com/intent/tweet?text=${encodedUrl}`)}
      source="./img/share_icon_twitter.svg"
      btnName="Twitter"
      mediaType={mediaType}
      gameData={gameData}
      sectionName={sectionName}
    />
  );
};

export default TwitterButton;
